import { appSlice } from "./reducer";

export const {
  appAlreadyOpen,
  appFailure,
  appReset,
  appRestart,
  appStartSuccess,
  connectionLost,
  connectionReestablished,
  detachModeChanged,
  enableDebugChanged,
  enterInactiveMode,
  enteredDashboard,
  sawMonitoringHelp,
  lastRoleChanged,
  presenceUpdated,
  themeSourceChanged,
  videoModeChanged,
  autoUpdateVideoMode,
  videoQualityChanged,
  whatsNewContentVersionChanged
} = appSlice.actions;
